// "We ship within Germany only" notice – see snippets/shipping-notice.liquid.
// Shows [data-shipping-notice] boxes when the visitor's detected country is not Germany,
// and fills the email link with a subject and the product or cart titles.
(function () {
  if (window.leverrasShippingNotice) return;
  window.leverrasShippingNotice = true;

  var STORAGE_KEY = 'leverras-shipping-country';

  function store(code) {
    try { sessionStorage.setItem(STORAGE_KEY, code); } catch (e) {}
  }

  function stored() {
    try { return sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function detectCountry() {
    var test = new URLSearchParams(window.location.search).get('shipping_notice_test');
    if (test) {
      test = test.toUpperCase();
      store(test);
      return Promise.resolve(test);
    }
    var cached = stored();
    if (cached !== null) return Promise.resolve(cached);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'browsing_context_suggestions.json?country[enabled]=true')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country;
        var code = c && c.handle ? String(c.handle).toUpperCase() : '';
        store(code);
        return code;
      })
      .catch(function () { return ''; });
  }

  function cartTitles() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return cart.items.map(function (i) { return '- ' + i.quantity + ' × ' + i.title; }).join('\n');
      })
      .catch(function () { return ''; });
  }

  function mailto(box, body) {
    return 'mailto:' + box.dataset.email +
      '?subject=' + encodeURIComponent(box.dataset.subject) +
      '&body=' + encodeURIComponent(body);
  }

  // The cart notification and drawer are re-rendered by the theme, so listen on the document.
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-shipping-notice-mail]');
    if (!link) return;
    var box = link.closest('[data-shipping-notice]');
    if (!box) return;
    evt.preventDefault();
    var countryLine = box.dataset.countryLabel + ' ';
    if (box.dataset.context === 'product') {
      window.location.href = mailto(box, box.dataset.productTitle + '\n' + box.dataset.productUrl + '\n\n' + countryLine);
      return;
    }
    cartTitles().then(function (titles) {
      window.location.href = mailto(box, (titles ? titles + '\n\n' : '') + countryLine);
    });
  });

  function showAll() {
    document.querySelectorAll('[data-shipping-notice]').forEach(function (box) { box.hidden = false; });
  }

  detectCountry().then(function (code) {
    if (!code || code === 'DE') return;
    showAll();
    // Boxes inside re-rendered cart markup (drawer) appear later.
    new MutationObserver(function () {
      document.querySelectorAll('[data-shipping-notice][hidden]').forEach(function (box) { box.hidden = false; });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
